import { makeApiCall } from '../core';
import type { ItemEnvelope, ListEnvelope, Role } from '@ruta/shared';

// =====================
// Role Management
// =====================

export const getRoles = async (): Promise<{ roles: Role[] }> => {
  const response = await makeApiCall<ListEnvelope<Role>>('GET', '/roles');
  return { roles: response.data };
};

export const createRole = async (data: {
  name: string;
  description?: string;
  permissions: string[];
}): Promise<{ role: Role }> => {
  const response = await makeApiCall<ItemEnvelope<{ role: Role }>>(
    'POST',
    '/roles',
    data,
  );
  return response.data;
};

export const updateRole = async (
  roleId: string,
  data: {
    name?: string;
    description?: string;
    permissions?: string[];
  },
): Promise<{ role: Role }> => {
  const response = await makeApiCall<ItemEnvelope<{ role: Role }>>(
    'PATCH',
    `/roles/${roleId}`,
    data,
  );
  return response.data;
};

export const deleteRole = async (roleId: string): Promise<void> => {
  await makeApiCall<void>('DELETE', `/roles/${roleId}`);
};
